import React, { useMemo } from 'react';

import { Selector } from '@fastlessjs/backoffice-layer/dist/components/atoms';
import { searchOrganizationsToSelect } from '@fastlessjs/backoffice-layer/dist/hooks/stores/useOrganizations';
import { Space, Typography } from 'antd';

type Props = {
  value: string;
  onChange: (organizationId: string) => void;
};

export const OrgSelector = ({ value, onChange }: Props) => {
  const fetch = useMemo(() => searchOrganizationsToSelect({ pageSize: 0 }), []);

  return (
    <Space align="center">
      <Typography.Text strong>Organization</Typography.Text>
      <Selector
        fetch={fetch}
        autoSelect
        style={{ minWidth: 260 }}
        placeholder="Select client organization"
        value={value || undefined}
        onChange={(v) => onChange(v as string)}
      />
    </Space>
  );
};
